import { $httpFhirApi } from '@/common/api/httpFhir.service';

// Searches that find what has to go with a removed session, note or task. Each takes every id at
// once, so removing a group costs one request per resource type rather than one per patient.

// A search spanning a whole group session can outgrow one page, so follow the next links.
export async function fetchAllPages(query) {
    const url = `${query}&_count=500`;
    const resources = [];
    let response = await $httpFhirApi.get(url);
    resources.push(...(response?.data || []));
    for (let page = 2; response?.originalData?.link?.some((link) => link?.relation === 'next') && response?.data?.length; page++) {
        // eslint-disable-next-line no-await-in-loop
        response = await $httpFhirApi.get(`${url}&_page=${page}`);
        resources.push(...(response?.data || []));
    }
    return resources.filter((resource) => resource != null);
}

const toDeleteRefs = (resources, resourceType) => resources.filter((resource) => resource?.id).map((resource) => ({ id: resource.id, resourceType }));

export const isFormTaskWithQR = (resource) =>
    resource?.resourceType === 'Task' && resource.focus?.id && resource.focus.resourceType === 'QuestionnaireResponse' && resource.code?.coding?.[0]?.code === 'form' && resource.for?.id;

export async function findAdverseEventsForEncounters(encounterIds) {
    if (!encounterIds.length) return [];
    return toDeleteRefs(await fetchAllPages(`AdverseEvent?encounter=${encounterIds.join(',')}&_elements=id`), 'AdverseEvent');
}

export async function findClinicalImpressionsForResponses(questionnaireResponseIds) {
    const ids = [...new Set(questionnaireResponseIds.filter(Boolean))];
    if (!ids.length) return [];
    return toDeleteRefs(await fetchAllPages(`ClinicalImpression?supportingInfo=${ids.join(',')}&_elements=id`), 'ClinicalImpression');
}

// The ClinicalImpressions of every form task's note.
export function findClinicalImpressionsForForms(formTasks) {
    return findClinicalImpressionsForResponses(formTasks.filter(isFormTaskWithQR).map((task) => task.focus.id));
}
